import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function FeaturedTreatments() {
  const {
    t
  } = useLanguage();
  return <section className="py-12 md:py-24 bg-brand-dark text-white relative" data-id="element-70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-71">
        <div className="text-center mb-10 md:mb-16" data-id="element-72">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-73">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-gold-light mb-4 md:mb-6" data-id="element-74">
              {t('featured.title')}
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-75"></div>
          </motion.div>
        </div>

        {/* Hero Treatment: Acne */}
        <motion.div className="bg-white/5 border border-brand-gold/30 p-8 md:p-12 rounded-sm mb-12 relative overflow-hidden" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-76">
          <div className="absolute top-0 right-0 bg-brand-gold text-white px-6 py-2 rounded-bl-lg font-bold text-sm tracking-wider flex items-center gap-2" data-id="element-77">
            <Trophy className="w-4 h-4" data-id="element-78" />
            {t('featured.badge')}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-79">
            <div data-id="element-80">
              <h3 className="text-3xl font-serif text-brand-gold-light mb-4 mt-4 lg:mt-0" data-id="element-81">
                {t('featured.hero_title')}
              </h3>
              <p className="text-gray-300 mb-6 text-lg" data-id="element-82">
                {t('featured.hero_desc')}
              </p>

              <div className="mb-6" data-id="element-83">
                <h4 className="text-white font-semibold mb-2" data-id="element-84">
                  {t('featured.who_title')}
                </h4>
                <p className="text-gray-400 text-sm" data-id="element-85">
                  {t('featured.who_desc')}
                </p>
              </div>

              <div className="flex flex-wrap gap-4 text-sm text-gray-300" data-id="element-86">
                <div className="bg-black/30 px-4 py-2 rounded-sm border border-white/10" data-id="element-87">
                  <span className="text-brand-gold font-semibold" data-id="element-88">
                    {t('featured.duration_label')}
                  </span>{' '}
                  {t('featured.duration_val')}
                </div>
                <div className="bg-black/30 px-4 py-2 rounded-sm border border-white/10" data-id="element-89">
                  <span className="text-brand-gold font-semibold" data-id="element-90">
                    {t('featured.freq_label')}
                  </span>{' '}
                  {t('featured.freq_val')}
                </div>
              </div>
            </div>

            <div data-id="element-91">
              <h4 className="text-white font-semibold mb-4 text-xl" data-id="element-92">
                {t('featured.achieve_title')}
              </h4>
              <ul className="space-y-4" data-id="element-93">
                {[t('featured.achieve_1'), t('featured.achieve_2'), t('featured.achieve_3'), t('featured.achieve_4'), t('featured.achieve_5')].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-94">
                    <CheckCircle2 className="w-5 h-5 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-95" />
                    <span className="text-gray-300" data-id="element-96">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </motion.div>

        {/* Other Featured */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-97">
          {[{
          title: t('featured.t1_title'),
          desc: t('featured.t1_desc')
        }, {
          title: t('featured.t2_title'),
          desc: t('featured.t2_desc')
        }, {
          title: t('featured.t3_title'),
          desc: t('featured.t3_desc')
        }, {
          title: t('featured.t4_title'),
          desc: t('featured.t4_desc')
        }].map((item, idx) => <motion.div key={idx} className="bg-white/5 border border-white/10 p-6 rounded-sm hover:border-brand-gold/50 transition-colors" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3 + idx * 0.1
        }} data-id="element-98">
              <h4 className="text-xl font-serif text-brand-gold-light mb-3" data-id="element-99">
                {item.title}
              </h4>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-100">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}